import { Hero } from "@components/cms/hero/Hero";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import type { HeroSliderModel } from "@lib/contentful/mappers/modules/heroSlider/types";
import { Box } from "@ecco/ui/box";
import { SwipeCarousel } from "@ecco/ui/swipe-carousel";
import { useState, type FC } from "react";

const widthMap = {
    medium: ["full", "full", "full", "full", "70%"],
    large: ["full", "full", "full", "full", "80%"],
    "full width": "full",
};

type HeroSliderProps = HeroSliderModel & { index?: number };

export const HeroSlider: FC<HeroSliderProps> = ({
    width = "full width",
    hasTimer,
    heroes,
    index,
}) => {
    const { getMultiple } = useMicrocopy();

    const [isVideoPlaying, setIsVideoPlaying] = useState<boolean>(true);
    const [activeSlide, setActiveSlide] = useState<number>(0);

    const microcopies = (() => {
        return getMultiple(CommonCMS.shared, [
            CommonCMS.slide.nextSlide,
            CommonCMS.slide.previousSlide,
        ]);
    })();

    return (
        <Box w={widthMap[width]} data-testid="HeroSlider">
            <SwipeCarousel
                navigation={{
                    nextSlideTitle: microcopies[CommonCMS.slide.nextSlide],
                    previousSlideTitle: microcopies[CommonCMS.slide.previousSlide],
                }}
                selectedSlideIndex={activeSlide}
                onSlideIndexChange={setActiveSlide}
                playback={{
                    hasTimer,
                    videoPlayback: {
                        isEnabled: true,
                        isPlaying: isVideoPlaying,
                        onPlayingChange: setIsVideoPlaying,
                    },
                }}
                indicator={"progress"}
            >
                {heroes.map((hero, heroIndex) => (
                    <Hero
                        hasNavigation
                        key={hero.id}
                        {...hero}
                        slideIndex={heroIndex}
                        index={index}
                        isCarousel
                        isVideoPlaying={isVideoPlaying}
                        setIsVideoPlaying={setIsVideoPlaying}
                        activeSlide={activeSlide}
                    />
                ))}
            </SwipeCarousel>
        </Box>
    );
};
